import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Home from "../containers/home/home";
import EmbedCarousel from "../containers/embedCarousel/embedCarousel";
import EmbedGrid from "../containers/embedGrid/embedGrid";

const getRoutes = (status) => {
  return (
    <Switch>
      <Route path="/home" component={Home} />
      <Route
        path="/embed/carousel/:city/:noOfCarousel"
        component={EmbedCarousel}
      />
      <Route
        path="/embed/grid/:city"
        component={EmbedGrid}
      />
      
      {/* <Redirect to="/home" /> */}
    </Switch>
  );
};

export default getRoutes;
